const $ = jQuery;
const $dropdown = $('#how_hear_about'),
	  $textarea = $('#how_hear_about_other_field');

function toggleTextArea(e) {
	if(e.params.data.id === "other") {
		$textarea.find('label span').removeClass('optional').text("");
		$textarea.slideToggle(200);
		$('#how_hear_about_other').attr('required', true);

	} else {
		$textarea.slideUp(200);
		$('#how_hear_about_other').attr('required', false);
		$textarea.find('label span').addClass('optional').text("(optional)");
	}
}

function init() {
	$dropdown.on('select2:select', toggleTextArea);
}

init();